import { types, actions } from './requests'
export const CLONETASKS_TYPES = {
    ...types('CLONETASKS'),
}
export const CLONETASKS_ACTIONS = {
    ...actions('CLONETASKS'),
}